import { HStack, Text } from "@chakra-ui/react";
import {
  MdOutlineMailOutline,
  MdOutlinePhoneEnabled,
  MdOutlineWebAsset,
} from "react-icons/md";
import { websiteParser } from "src/lib/utils";
import * as ga from "../lib/ga";
import InstallerContactDetailsModal from "./InstallerContactDetailsModal";

// function to send custom google analytics event on website click
const sendReferralEvent = (name, channel) =>
  ga.event({
    action: "referral",
    params: {
      name: name,
      channel: channel,
    },
  });

export default function ContactDetails(installer) {
  const { email, telephone, website, name } = installer;

  return (
    <InstallerContactDetailsModal voltwise_id={installer.voltwise_id}>
      {website && (
        <HStack>
          <MdOutlineWebAsset color={"gray"} />
          <a
            onClick={() => {
              sendReferralEvent(name, "website");
            }}
            href={`//${websiteParser(website)}`}
            target="_blank"
            rel="noreferrer"
          >
            {websiteParser(website)}
          </a>
        </HStack>
      )}

      {email && (
        <HStack>
          <MdOutlineMailOutline color={"gray"} />
          <a
            href={`mailto:${email}`}
            onClick={() => {
              sendReferralEvent(name, "email");
            }}
          >
            {email}
          </a>
        </HStack>
      )}

      {telephone && (
        <HStack>
          <MdOutlinePhoneEnabled color={"gray"} />
          <Text>{telephone}</Text>
        </HStack>
      )}
    </InstallerContactDetailsModal>
  );
}
